import arrowleft from "@Images/NewUI/Vector.png";
import "@Styles/mandate.css";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "react-spinner-material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "toolcool-range-slider";
import DisclaimerImg from "../../../Images/NewUI/disclaimer.png";
import Downward from "../../../Images/NewUI/downward.png";
import {
  applyForLoan,
  create_ckyc,
  getLoanCalculation,
  getReasonForLoan,
  getRepaymentDate,
  notifyVisitorEvent,
} from "../../../Redux/ApplyLoan/action";
import { getDocumentStatus } from "../../../Redux/Manual_Kyc_Details/action";
import ToastMsg from "../../../helper/ToastMsg";
import { withRouter } from "../../../hooks/withRouter";
import { recordEvent } from "../../../utils/appFlyer";
import { trackOfferApproved } from "../../../utils/metaPixel";
import { Loader } from "../Common/Loader";
import { trackLoanOfferAccepted } from "../../../utils/ga4";

const ApplyLoan = (props) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("gpay_token");

  const [userCreditList, setUserCreditList] = useState(
    props.userDetail?.user_detail?.customusermodel?.usercredit,
  );
  const [loan_type, setLoanType] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [repayment_date, setRepaymentDate] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [processing_fee, setProcessing_fee] = useState("");
  const [gst, setGst] = useState("");
  const [loader, setLoader] = useState(false);
  const [processing_fee_less_1000_amount, setProcessing_fee_less_1000_amount] =
    useState(100);
  const [processing_above_2000, setProcessing_above_2000] = useState("");
  const [gst_above_2000, setGst_above_2000] = useState("");
  const [gst_below_1000, setGst_below_1000] = useState(18);
  const [gst_between_1000_2000, setGst_between_1000_2000] = useState("");
  const [tpf_above_2000, setTpf_above_2000] = useState("");
  const [tpf_below_1000, setTpf_below_1000] = useState(118);
  const [tpf_between_1000_2000, setTpf_between_1000_2000] = useState("");
  const [tenure_days, setTenure_days] = useState("");
  const [processing_between_1000_2000, setProcessing_between_1000_2000] =
    useState("");
  const [repayment_amount, setRepayment_amount] = useState("");
  const [rate_of_interest, setRate_of_interest] = useState("");
  const [emi_repayement_amount, setEmi_repayement_amount] = useState("");
  const [processing_fee_1000_2000, setProcessing_fee_1000_2000] = useState("");
  const [payday_visible, setPayday_visible] = useState(false);
  const [repayDate, setRepayDate] = useState("");
  const [repayment_date_options_emi, setRepayment_date_options_emi] =
    useState("");
  const [emiDate, setEmiDate] = useState([]);
  const [loanReason, setLoanReason] = useState("");
  const [maxLoanMaount, setMaxLoanMaount] = useState(0);
  const [erroramount, setErroramount] = useState("");
  const [toastLimit, setToastLimit] = useState(true);
  const [reasonList, setReasonList] = useState([]);
  const [loanCalculations, setLoanCalculations] = useState({});
  const [spinner, setSpinner] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [isReasonOpen, setIsReasonOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [step, setStep] = useState(0);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const storedLoanAmount = localStorage.getItem("loanAmount");
    const storedLoanReason = localStorage.getItem("loanReason");

    setSelectedReason(storedLoanReason);
    setLoanAmount(storedLoanAmount);
    handleReasonSelect(storedLoanReason);

    const userId = props.userDetail?.user_detail?.id; 

    recordEvent({
              eventName: "offer_screen",
              eventParams: { Platform: "web" },
              userId: userId
            });

  }, []);

  useEffect(() => {
    console.log("sticky-button-container");

    const userLevel =
      props.userDetail?.user_detail?.customusermodel?.user_level;
    let {
      processing_fee,
      processing_fee_1000_2000,
      processing_fee_less_1000_amount,
      rate_of_interest,
      gst,
    } = userLevel ? userLevel : "";

    // this.setState({

    handleReasonForLoan();
    setProcessing_fee(processing_fee);
    setProcessing_fee_less_1000_amount(processing_fee_less_1000_amount);
    setRate_of_interest(rate_of_interest);
    setProcessing_fee_1000_2000(processing_fee_1000_2000);
    setGst(gst);
    fetchRepaymentDate("P");

    userCreditList.map((usercredit) => {
      if (usercredit.loan_type === "P") {
        setMaxLoanMaount(usercredit.credit_limit);
        console.log(maxLoanMaount, "maxloanamount");
      }
    });
  }, []);

  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;

    const onChange = (evt) => {
      setPayday_visible(false);
      const customEvent = evt;
      // console.log(customEvent.detail.value, "checksliderconsol");

      setLoanAmount(customEvent.detail.value);
    };
    slider?.addEventListener("change", onChange);

    return () => {
      slider?.removeEventListener("change", onChange);
    };
  }, []);

  const handleGetLoanCalculation = (loanAmount, repayDate) => {
    setSpinner(true);
    const token = localStorage.getItem("gpay_token");
    let data = {
      loan_type: loan_type,
      amount: loanAmount || 0,
      repayment_date: repayDate || "2024-07-01",
    };
    props
      .getLoanCalculation(data, token)

      .then((res) => {
        setSpinner(false);
        const responseData = res?.data;

        setLoanCalculations(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleReasonForLoan = () => {
    props
      .getReasonForLoan(token)
      .then((res) => {
        if (res.status === 200) {
          setReasonList(res.data.data);
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const notify = (err) => {
    toast.error(err, {
      position: "top-center",
      autoClose: 2000,
    });
  };
  console.log(maxLoanMaount, "maxxxloanamounttt");
  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      if (Number(e.target.value) <= Number(maxLoanMaount)) {
        setLoanAmount(e.target.value);
      } else {
        setLoanAmount(maxLoanMaount);
      }
    }
  };
  const saveReasonForLoan = (reason) => {
    setLoanReason(reason);
  };

  const fetchRepaymentDate = (loan_type) => {
    setLoanType(loan_type);
    setStep("100");
    if (loan_type !== "") {
      props
        .getRepaymentDate(loan_type, token)
        .then((res) => {
          if (res?.repayment_date_options?.length === 0) {

            setIsButtonDisabled(true);
            setRepayDate(res?.repayment_date[0]);
            setEmiDate(res?.repayment_date);
          }
          console.log(repayDate, "rapyamrnt datteeeee");
          setRepaymentDate(res.repayment_date_options);
          setRepayment_date_options_emi(res.repayment_date_options_emi);
          if (!res.repayment_date_options == {}) {
            res.repayment_date_options.map((item, key) => {
              let current_date = moment(new Date());
              let new_date = moment(item).format("YYYY/DD/MM");

              let tenure =
                moment(new_date).diff(moment(current_date), "days") > 0
                  ? moment(new_date).diff(moment(current_date), "days")
                  : 0;

              setTenure_days(tenure + 1);
            });
          } else {
            //  console.log("pp",res?.repayment_date[0])
            let date1 = moment(res?.repayment_date[0]).format("YYYY/MM/DD");
            let temp = moment(date1).diff(moment(new Date()), "days");
            if (!repayDate) {
              setTenure_days(temp + 1);
            }
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    } else {
      setRepaymentDate([]);
      setRepayment_date_options_emi("");
    }
  };
  const setRepayment = (e) => {
    setRepayDate(e);
    if (e !== "") {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  };
  const processingFeeCalculation = () => {
    if (loanAmount > 2000) {
      let cal = Math.round((parseInt(loanAmount) * processing_fee) / 100);
      let gst_cal = (cal * gst) / 100;
      let tpf = cal + gst_cal;
      setProcessing_above_2000(cal);
      setGst_above_2000(gst_cal);
      setTpf_above_2000(tpf);
    } else if (loanAmount <= 1000) {
      console.log(
        processing_fee_less_1000_amount,
        "processing_fee_less_1000_amount",
      );
      // setProcessing_fee_less_1000_amount(processing_fee_less_1000_amount);
    } else if (1000 < loanAmount < 2000) {
      let result = Math.round((parseInt(loanAmount) * processing_fee) / 100);
      let gst_calulation = (result * gst) / 100;
      let tpf_2000 = result + gst_calulation;
      setProcessing_between_1000_2000(result);
      setGst_between_1000_2000(gst_calulation);
      setTpf_between_1000_2000(tpf_2000);
    }
    setIsButtonDisabled(true);
  };

  const calculateTenureDays = () => {
    if (repayment_date) {
      repayment_date.map((item, key) => {
        let date = new Date();
        let current_date = moment(date).format("YYYY/MM/DD");
        let new_date = moment(item).format("YYYY/MM/DD");
        let tenure =
          moment(new_date).diff(moment(current_date), "days") > 0
            ? moment(new_date).diff(moment(current_date), "days")
            : 0;
        setTenure_days(tenure + 1);
      });
    }
  };

  const calculateRepaymentAmount = () => {
    // console.log("tenure_days",tenure_days)

    let result =
      (parseInt(loanAmount) * rate_of_interest * (tenure_days + 1)) / 100;
    setRepayment_amount(parseInt(result) + parseInt(loanAmount));
  };
  const calculateEmiRepaymentAmount = () => {
    let month =
      loan_type.length === 3
        ? loan_type.substr(loan_type.length - 2)
        : loan_type.substr(loan_type.length - 1);
    const roi = (30 * rate_of_interest) / 100;

    const result = Math.round(
      loanAmount * ((roi * (1 + roi) ** month) / ((1 + roi) ** month - 1)),
    );
    setEmi_repayement_amount(result);
  };

  const calculateEmi = () => {
    Object.entries(repayment_date_options_emi).map(([key, value]) => {
      let date = moment(key).format("YYYY/MM/DD");
      if (date === repayDate) {
        setEmiDate(value);
      }
    });
  };

  const handleSelect = (date) => {
    setSelectedDate(date);
    setRepayment(date);
    let formattedDate = moment(date).format("YYYY/MM/DD");
    let temp = moment(formattedDate).diff(moment(new Date()), "days");
    setPayday_visible(false);
    setTenure_days(temp + 1);
    setIsOpen(false);
  };
  const handleCalculation = () => {
    processingFeeCalculation();
    calculateRepaymentAmount();
    calculateEmiRepaymentAmount();
    calculateEmi();
    setPayday_visible(!payday_visible);
  };
  const submitForm = () => {
    let temp = Number(1000) - Number(loanAmount);
    if (temp > 0) {
      notify(`Loan amount should be between 1000 to  ${maxLoanMaount}!`);
      return;
    } else {
      const userId = props.userDetail?.user_detail?.id;
      nv("event", "Loan_Amount_Selected", {
        user_id: userId,
        selected_amount: loanAmount,
        tenure: tenure_days,
        repayment_amount: repayment_amount,
        user_type: props.userDetail?.user_detail?.customusermodel?.user_type || "",
      }, "100", 1);
      localStorage.setItem("loan_type", loan_type);
      localStorage.setItem("loanAmount", loanAmount);
      localStorage.setItem("repayDate", repayDate);
      localStorage.setItem("loanReason", loanReason);
      localStorage.setItem("loan_type_description", "Credit Line (Cash)");
      let data = {
        amount: loanAmount,
        loan_type: loan_type,
        reason_for_loan: loanReason,
        repayment_date: repayDate,
      };
      props.create_ckyc(data, token).then((res) => {
        console.log(res, "res_of_createckyc");

        setLoader(true);
        // console.log(res?.data?.data?.kyc_verified,"verifycheck");
        if (res?.data?.data?.kyc_verified == "PENDING_VERIFICATION") {
          setLoader(false);

          navigate("/kycverifyinprogress");
          return;
        }
        if (res?.data?.data?.kyc_verified == "NOT_VALID") {
          navigate("/kycnotdone");
          return;
        }
        if (res?.data?.data?.kyc_verified === "NOT_SUBMITTED") {
          navigate("/manual_verify?keyfrom=apply_now");
          return;
        }

        props.getDocumentStatus(token).then((res) => {
          // console.log(res, "res_of_getdocstatus");

          res.data.map((details) => {
            if (details.key_fact_screen === true) {
              navigate("/key-statements?keyfrom=Applyloan");
            } else {
              if (details.bank_details_verified == "NOT_VALID") {
                let bankData = {
                  heading: "Sorry !",
                  subHeading:
                    "Bank details could not be verified. Please try again",
                  message: "",
                  but_name: "Try Again",
                  route: "bank",
                  backbtn: "show",
                };
                navigate(
                  `/not_eligible_for_loan?msg=${JSON.stringify(bankData)}`,
                );
                return;
              }
              if (details.bank_details_verified == "PENDING_VERIFICATION") {
                let bankData = {
                  heading: "Please Wait!",
                  subHeading: "Please try after sometime",
                  message: "Your bank details are in pending verification.",
                  but_name: "Back to Home",
                  route: "bank",
                };

                navigate(`/message?details=${JSON.stringify(bankData)}`);
                return;
              }
              if (details.bank_details_verified == "NOT_SUBMITTED") {
                navigate("/add_bank_details");
                return;
              }
              trackLoanOfferAccepted();
              if (res.data[0].emandate_verified === "S") {
                navigate("/loandetail");
              }
              if (
                res.data[0].esign_verified === "S" &&
                res.data[0].emandate_verified === "S"
              ) {
                navigate("/loandetail?someCheck=true");
              } else {
                navigate("/autodebit");
              }
              //props.history.push("/agreement");
            }
          });
        });
      }).catch((err) => {
        setLoader(false);
        let error = err?.response?.data?.error || err?.response?.data?.message || "Something went wrong. Please try again.";
        ToastMsg(error, "error");
      });
    }
  };
  const [selectLoanType, setSeletLoanType] = useState("");

  const handleReasonSelect = (reason) => {
    setSelectedReason(reason);
    saveReasonForLoan(reason);
    setIsReasonOpen(false);
  };
  const loanTypeHandle = (e) => {
    // console.log('loanTypeHandle(e)',e.target.value)
    let val = e.target.value;
    setSeletLoanType(val);
    console.log(selectLoanType);
  };
  // console.log('selectLoanType',selectLoanType==='');
  console.log(repayDate, "loan amount");
  // console.log(repayment_date, "checkrepayment");
  console.log(loanCalculations, "here_her");
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        limit={1}
        closeButton={false}
      />
      {loader ? (
        <Loader />
      ) : (
        <div className="main_div payme_body">
          {isLargeScreen && (
            <>
              <div className="ml-28 mt-10 pb-3 shadowline flex  sticky-header align-center">
                <a
                  href="#"
                  onClick={() => {
                    window.location.href = "/super-loan-dashboard";
                  }}
                >
                  <img src={arrowleft} style={{ marginRight: 40 }} />
                </a>
                <div className="mt-2">
                  <h2 className="paymecolour">One Time Payment</h2>
                  <h2>Loan Application</h2>
                </div>
              </div>
              <span className="loantypefont container font20600 py-1">
                Loan Type:{" "}
                <span className="paymecolourone">Credit Line (Cash)</span>
              </span>
            </>
          )}
          <div className="toolbarRespo">
            {!isLargeScreen && (
              <>
                <div className="applyloanfix mt-10 pt-2 shadowline profilelowersec maxWidth450 sticky-header align-center">
                  <a
                    href="#"
                    onClick={() => {
                      window.location.href = "/super-loan-dashboard";
                    }}
                  >
                    <img
                      src={arrowleft}
                      className="mt-2"
                      style={{ marginRight: 28 }}
                    />
                  </a>
                  <div>
                    <h2 style={{ marginTop: 17 }} className="paymecolour">
                      One Time Payment
                    </h2>
                    <h2>Loan Application</h2>
                  </div>
                </div>
                <span className="loantypefont font20600 py-1">
                  Loan Type:{" "}
                  <span className="paymecolourone">Credit Line (Cash)</span>
                </span>
              </>
            )}
            <div
              className="aligncentrehere container pd-l-r-zero containerapplynow"
            >
              <div
                className="cardstructureapplyloan mt-20 pd-l-r-zeroUpdate  containerapplynow"
              >
                <div className="flex_row justifycontent  align_flex_start">
                  <div className="flex_row ">
                    <div className="">
                      <div
                        style={{ marginTop: 15 }}
                        className="flex_row align_centre"
                      >
                        {loan_type == "P" ? (
                          <span className="loanamountText md:ms-2">
                            Select Loan Amount{" "}
                            <span className="text-muted small">(in ₹)</span>
                          </span>
                        ) : (
                          <span className="loanamountText ml-10 mt-16">
                            Select Loan Amount
                            <span className="inrupee">(in ₹)</span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    style={{ marginRight: 10 }}
                    className="marginTop displayfix align_centre "
                  ></div>
                </div>
                <input
                  className="applyloanInput"
                  placeholder={"₹ " + 0}
                  name="loanAmount"
                  type="text"
                  value={loanAmount}
                  onChange={handleChange}
                ></input>
                <div className="progressbar">
                  <div className="applyloanslider mt-10">
                    <toolcool-range-slider
                      max={maxLoanMaount}
                      ref={sliderRef}
                      min="1000"
                      step={step}
                      value={loanAmount}
                      slider-height="4px"
                      slider-bg-fill="#3BBE9D"
                      pointer-bg="#3BBE9D"
                      pointer-border="2px solid white"
                      slider-border="rgba(252, 102, 3, 0.1)"
                      onChange={(e) => {
                        console.log(e, "consoleeeee");
                      }}
                    ></toolcool-range-slider>
                    {/* <toolcool-range-slider max={maxLoanMaount} ref={ sliderRef } min="500" step="1" value={loanAmount}  slider-height="4px" slider-bg-fill="rgba(252, 102, 3, 1)" pointer-bg="rgba(252, 102, 3, 1)" pointer-border="2px solid white" slider-bg="rgba(252, 102, 3, 0.3)" onChange={(e)=>{console.log(e,"consoleeeee");}}></toolcool-range-slider> */}
                    {/* {slidercheck  ?<toolcool-range-slider max={maxLoanMaount} ref={ sliderRef } min="500" step="1" value={loanAmount}  slider-height="4px" slider-bg-fill="rgba(252, 102, 3, 1)" pointer-bg="rgba(252, 102, 3, 1)" pointer-border="2px solid white" slider-bg="rgba(252, 102, 3, 0.3)" onChange={(e)=>{console.log(e,"consoleeeee");}}></toolcool-range-slider>: <toolcool-range-slider max="0"  disabled min="0" step="0"   slider-height="4px" slider-bg-fill="rgba(252, 102, 3, 1)" pointer-bg="rgba(252, 102, 3, 1)" pointer-border="2px solid white" slider-bg="rgba(252, 102, 3, 0.3)" ></toolcool-range-slider>} */}
                    <div className="justifycontentSpacebetn flex_row managemargin">
                      <span className="">₹ 1000</span>
                      <span>
                        ₹{" "}
                        {maxLoanMaount
                          ?.toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" pd-l-r-zero">
                {repayment_date?.length > 0 ? (
                  <div className="repaymentdisclaimer flex_row ">
                    <img
                      // className="disclaimerimgapplyloanmarginfix"
                      style={{ marginRight: 13, marginLeft: 10 }}
                      width={16}
                      height={16}
                      src={DisclaimerImg}
                    ></img>
                    <p
                    // className="selectrepaymentdatedisclaimercolour mr-5 "
                    >
                      Over 90% of people select repayment date as their salary
                      date.
                    </p>
                  </div>
                ) : (
                  <div style={{ marginBottom: "20px" }}></div>
                )}
              </div>

              {/* <h5 className="repayment_style">Select Repayment Date</h5> */}
              {repayment_date?.length > 0 ? (
                <div
                  className="cardstructureapplyloan p-3 mt-20 mb-4 containerapplynow"
                >
                  <span className="loanamountText flex">
                    Select Repayment Date
                  </span>
                  <div className="custom-dropdown-container">
                    <div
                      className="custom-dropdown"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      {selectedDate
                        ? moment(selectedDate).format("DD/MM/YYYY")
                        : "Select Date"}
                      <span className={`arrow ${isOpen ? "open" : ""}`}></span>
                    </div>
                    {isOpen && (
                      <div className="custom-dropdown-menu">
                        {repayment_date.map((item, index) => (
                          <div
                            key={index}
                            className="custom-dropdown-item outlinegeneral"
                            onClick={() => handleSelect(item)}
                          >
                            {moment(item).format("DD/MM/YYYY")}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div
                className="cardSeeCalculation  mb-20 container"
              >
                <div
                  onClick={() => {
                    if (loanAmount && repayDate) {
                      setPayday_visible(!payday_visible);
                      handleGetLoanCalculation(loanAmount, repayDate);
                      handleCalculation();
                    }
                  }}
                  className="seecalculationpadding"
                >
                  {/* <div className="justifycontentSpacebetn flex_row "> */}
                  <div className="flex justify-content-between align-items-center">
                    <a cla className="translatefix5">
                      See calculations
                    </a>
                    <img
                      width={24}
                      height={24}
                      src={Downward}
                    ></img>
                  </div>
                </div>

                {payday_visible && loan_type === "P" ? (
                  <div>
                    {spinner ? (
                      <Spinner
                        radius={30}
                        color={"#333"}
                        stroke={2}
                        visible={true}
                      />
                    ) : (
                      <div className="toggle card-height-small w-100 mx-auto bg-white ">
                        <div className="d-flex flex-column justify-content-between">
                          <div className="pt-0 pb-0">
                            <table className="emi_table">
                              <tr>
                                <td style={{ marginRight: 20 }}>Repayment</td>
                                <td className="seecalculation">
                                  ₹
                                  {loanCalculations?.repayment_amount
                                    ?.toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ||
                                    "NA"}
                                </td>
                              </tr>
                              <tr>
                                <td>Interest(per day)</td>
                                <td className="seecalculation">
                                  {loanCalculations?.roi}%
                                </td>
                              </tr>
                              <tr>
                                <td>Processing Fee</td>
                                <td className="seecalculation">
                                  ₹{loanCalculations?.processing_fee}
                                </td>
                                {/* {loanAmount > 2000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(processing_above_2000.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}
                                      </strong>
                                    </td>
                                  ) : loanAmount <= 1000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{processing_fee_less_1000_amount}
                                      </strong>
                                    </td>
                                  ) : (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{processing_between_1000_2000}
                                      </strong>
                                    </td>
                                  )} */}
                              </tr>
                              <tr>
                                <td>GST On Processing Fee</td>
                                <td className="seecalculation">
                                  {" "}
                                  ₹{loanCalculations?.gst_on_processing_fee}
                                </td>

                                {/* {loanAmount > 2000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(gst_above_2000)}
                                      </strong>
                                    </td>
                                  ) : loanAmount <= 1000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(gst_below_1000)}
                                      </strong>
                                    </td>
                                  ) : (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(gst_between_1000_2000)}
                                      </strong>
                                    </td>
                                  )} */}
                              </tr>
                              <tr>
                                <td>Total Processing Fee</td>
                                <td className="seecalculation">
                                  ₹{loanCalculations?.total_processing_fee}
                                </td>
                                {/* {loanAmount > 2000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(tpf_above_2000)}
                                      </strong>
                                    </td>
                                  ) : loanAmount <= 1000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(tpf_below_1000)}
                                      </strong>
                                    </td>
                                  ) : (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(tpf_between_1000_2000)}
                                      </strong>
                                    </td>
                                  )} */}
                              </tr>
                              <tr>
                                <td>Total disbursal amount</td>
                                <td className="seecalculation">
                                  {" "}
                                  ₹{loanCalculations?.disbursed_amount}
                                </td>
                                {/* {loanAmount > 2000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(loanAmount) - Math.round(tpf_above_2000)}
                                      </strong>
                                    </td>
                                  ) : loanAmount <= 1000 ? (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(loanAmount) - Math.round(tpf_below_1000)}
                                      </strong>
                                    </td>
                                  ) : (
                                    <td>
                                      <strong style={{ fontWeight: 600 }}>
                                        ₹{Math.round(loanAmount) - Math.round(tpf_between_1000_2000)}
                                      </strong>
                                    </td>
                                  )} */}
                              </tr>
                              <tr>
                                <td>Repayment Date</td>
                                <td className="seecalculation">
                                  {loanCalculations?.repayment_date}
                                  {/* {repayDate
                                        ? moment(repayDate).format("DD-MM-YYYY")
                                        : "NA"} */}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : payday_visible && loan_type !== "P" ? (
                  <div>
                    <div className="toggle card-height-small w-100 mx-auto bg-white shadow-lg">
                      <div className="d-flex flex-column justify-content-between">
                        <div className="pt-0 pb-0">
                          <table className="emi_table">
                            <thead>
                              <tr>
                                <td>Month</td>
                                <td>Due Date</td>
                                <td>Repayment</td>
                              </tr>
                            </thead>
                            {emiDate.map((item, index) => {
                              return (
                                <tbody key={index}>
                                  <tr>
                                    <td>{index + 1} EMI</td>
                                    <td>{moment(item).format("DD/MM/YYYY")}</td>
                                    <td>₹{emi_repayement_amount}</td>
                                  </tr>
                                </tbody>
                              );
                            })}
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="toggle card-height-small w-100 mx-auto bg-white shadow-lg">
                      <div className="d-flex flex-column justify-content-between">
                        <div className="pt-0 pb-0">
                          <table className="emi_table">
                            <tr>
                              <td>Interest(per day)</td>
                              <td>₹{rate_of_interest}%</td>
                            </tr>
                            <tr>
                              <td>Processing Fee</td>
                              {loanAmount > 2000 ? (
                                <td>₹{processing_above_2000}</td>
                              ) : loanAmount <= 1000 ? (
                                <td>₹{processing_fee_less_1000_amount}</td>
                              ) : (
                                <td>₹{processing_between_1000_2000}</td>
                              )}
                            </tr>
                            <tr>
                              <td>GST On Processing Fee</td>
                              {loanAmount > 2000 ? (
                                <td>₹{gst_above_2000}</td>
                              ) : loanAmount <= 1000 ? (
                                <td>₹{gst_below_1000}</td>
                              ) : (
                                <td>₹{gst_between_1000_2000}</td>
                              )}
                            </tr>
                            <tr>
                              <td>Total Processing Fee</td>
                              {loanAmount > 2000 ? (
                                <td>₹{tpf_above_2000}</td>
                              ) : loanAmount <= 1000 ? (
                                <td>₹{tpf_below_1000}</td>
                              ) : (
                                <td>₹{tpf_between_1000_2000}</td>
                              )}
                            </tr>
                            <tr>
                              <td>Total disbursal amount</td>
                              {loanAmount > 2000 ? (
                                <td>₹{loanAmount - tpf_above_2000}</td>
                              ) : loanAmount <= 1000 ? (
                                <td>₹{loanAmount - tpf_below_1000}</td>
                              ) : (
                                <td>₹{loanAmount - tpf_between_1000_2000}</td>
                              )}
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div
                className="cardSeeCalculation p-3  containerapplynow"
              >
                <div>
                  <span className="loanamountText flex mt-16">
                    Reason for Loan
                  </span>
                  <div
                    className={`custom-dropdown-container ${
                      isReasonOpen ? "dropdown-open" : ""
                    }`}
                  >
                    <div
                      className="custom-dropdown "
                      onClick={() => setIsReasonOpen(!isReasonOpen)}
                    >
                      <span>{selectedReason || "Select reason"}</span>
                      <div className={`arrow ${isReasonOpen ? "open" : ""}`} />
                    </div>
                    {isReasonOpen ? (
                      <div className={`custom-dropdown-menu-loanrepay `}>
                        {reasonList.map((reason, index) => (
                          <div
                            key={index}
                            className="custom-dropdown-item outlinegeneral "
                            onClick={() => handleReasonSelect(reason)}
                          >
                            {reason}
                          </div>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center justifycontentcentre sticky-button-container">
            {loan_type && loanAmount && loanReason && repayDate ? (
              <div
                onClick={() => {
                  if (toastLimit) {
                    setToastLimit(false);
                    trackOfferApproved({
                      approvedAmount: loanAmount,
                      loanType: loan_type,
                      repayment_date: repayDate,
                      reason_for_loan: loanReason,
                      approvalDate: new Date().toISOString(),
                    });
                    submitForm();
                    setTimeout(() => {
                      setToastLimit(true);
                    }, 2000);
                  }
                }}
                className="GetNowBtnrepayvd continue_btn_margin"
              >
                Continue
              </div>
            ) : (
              <div className="GetNowBtnrepayvd continue_btn_margin opacity-50">
                Continue
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    getRepaymentDate,
    applyForLoan,
    getDocumentStatus,
    getReasonForLoan,
    getLoanCalculation,
    notifyVisitorEvent,
    create_ckyc,
  })(ApplyLoan),
);
